import { render, staticRenderFns } from "./ToShip.vue?vue&type=template&id=fcc9da96&scoped=true&"
import script from "./ToShip.vue?vue&type=script&lang=js&"
export * from "./ToShip.vue?vue&type=script&lang=js&"
import style0 from "./ToShip.vue?vue&type=style&index=0&id=fcc9da96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc9da96",
  null
  
)

export default component.exports